/**
 * Decides whether an expansion (new nodes on a non-empty canvas) may relayout now.
 *
 * R24 stability rule: SSE `node_discovered` / `edge_discovered` flushes never
 * relayout. While a stream holds layout the answer is `hold`; the hold is
 * released at a step boundary, completion or a user action, and the pending
 * nodes are then laid out once. Outside a stream the 600 ms throttle applies so
 * programmatic expansions cannot slot-machine the canvas.
 */
export type ExpansionLayoutDecision = 'run' | 'hold' | 'throttle';

export const LAYOUT_EXPANSION_THROTTLE_MS = 600;

export function decideExpansionLayout(input: {
    isExpansion: boolean;
    streamHold: boolean;
    msSinceLastLayout: number;
}): ExpansionLayoutDecision {
    if (!input.isExpansion) return 'run'; // initial load is never held or throttled
    if (input.streamHold) return 'hold';
    if (input.msSinceLastLayout < LAYOUT_EXPANSION_THROTTLE_MS) return 'throttle';
    return 'run';
}
